import Entity from '../entity';
export default class FlightProvider extends Entity<number> {
  name: string;
  companyType: number;
  type: number;
  logoImageUrl: string;
  accountNumber: any;
  accountRating: any;
  addressType: any;
  addressCityId: any;
  addressCountryId: any;
  addressFax: any;
  addressLatitude: any;
  addressLongitude: any;
  doNotBulkEmail: any;
  doNotBulkPostalMail: any;
  doNotEmail: any;
  doNotFax: any;
  doNotPhone: any;
  doNotPostalMail: boolean;
  doNotSendMailMerge: any;
  emailAddress1: any;
  emailAddress2: any;
  emailAddress3: any;
  fax: any;
  ftpSiteUrl: any;
  isPrivate: any;
  parentId: any;
  primaryContactId: any;
  secondaryContactId: any;
  reservationContactId: any;
  accountingContactId: any;
  revenue: number;
  status: number;
  phone1: any;
  phone2: any;
  phone3: any;
  territoryId: any;
  webSiteUrl: any;
  contacts: any[];
  sendConfirmationEmailTo: number;
  confirmationContactId: any;
  confirmationContact: any;
  confirmationMailLanguageId: string;
  companyEmailSettings: any[];
  companyContacts: any[];
  shortCode: any;
}
